import React, { useState } from 'react';
import { Field, getIn } from 'formik';
import classnames from 'classnames';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import './datepicker.scss';

const Datepicker = ({ name, value, label, form, selected, onChange, error, placeholder,  ...props }) => {

  const [focused, setFocused] = useState(0);

  const wrapperClass = classnames({
    'form-group form-group-select': true
  });

  const inputClass = classnames({
    'form-control datepicker': true
  });

  const labelClass = classnames({
    'form-label': true
  });

  const hasError = (error, errors, touched, name) => {
    return error || ((getIn(touched, name) || focused === 2 ) && getIn(errors, name));
  };


  return (
    <Field name={name}>
      {({ field, form: { touched, errors, setFieldValue }, handleBlur }) => (
        <div
          className={`${wrapperClass} ${
            hasError(error, errors, touched, field.name) ? 'has-error' : ''
          }`}
        >
          <label className={labelClass}> {label} <br/>
            <DatePicker
              minDate={new Date()}
              className={inputClass}
              selected={selected}
              onChange={onChange}
              placeholderText='Select a date'
              onFocus={e => setFocused(1)}
              onBlur={e => setFocused(2) }
            />
          </label>
        {hasError(error, errors, touched, field.name) && (
          <div className="input-feedback">
            {error || getIn(errors, field.name)}
          </div>
        )}
      </div>
    )}
  </Field>
  );
}

export default Datepicker;
